import React__default, { forwardRef } from 'react';
import { AlertBox, Span, AlertBoxDismissButton } from '@vp/swan';
import { useProductOptionsTranslations } from '../product-options-translations/product-option-translations.mjs';
import { buildUnwindingMessageHtml } from '../../helpers/buildUnwindingMessageHtml.mjs';

const OptionNotification = forwardRef(({ notificationOptions }, ref) => {
    const { optionCausingUnselect, optionsUnselected } = notificationOptions;
    if (!optionCausingUnselect || !optionsUnselected) {
        return React__default.createElement(React__default.Fragment, null);
    }
    const { i18n } = useProductOptionsTranslations();
    const notificationHtml = buildUnwindingMessageHtml(i18n, "unwindingAlertMessage", optionsUnselected, optionCausingUnselect);
    return (React__default.createElement(AlertBox, { ref: ref, skin: "warning", marginTop: 6, marginBottom: "6" },
        React__default.createElement(Span, { fontWeight: "normal", dangerouslySetInnerHTML: { __html: notificationHtml } }),
        React__default.createElement(AlertBoxDismissButton, { accessibleText: i18n("dismissAlert") })));
});

export { OptionNotification };
//# sourceMappingURL=option-notification.mjs.map
